var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegistrationTrust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.0226,
    r: 20,
    fill: "#CACBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6396 16.8656H14.3604C12.9446 16.8656 11.7969 18.0133 11.7969 19.4291V29.0678C11.7969 30.4835 12.9446 31.6312 14.3604 31.6312H25.6396C27.0554 31.6312 28.2031 30.4835 28.2031 29.0678V19.4291C28.2031 18.0133 27.0554 16.8656 25.6396 16.8656Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3604 14.0531C14.3604 10.9383 16.8852 8.41346 20 8.41346C23.1148 8.41346 25.6396 10.9383 25.6396 14.0531V16.8656H22.8271V14.0531C22.8271 12.4945 21.5592 11.226 20 11.226C18.4408 11.226 17.1729 12.4945 17.1729 14.0531V16.8656H14.3604V14.0531Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9453 23.966V28.4678H21.0547V23.966C21.6852 23.601 22.1094 22.9201 22.1094 22.1396C22.1094 20.9748 21.1648 20.0303 20 20.0303C18.8352 20.0303 17.8906 20.9748 17.8906 22.1396C17.8906 22.9201 18.3148 23.6016 18.9453 23.966Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationTrust);
export default __webpack_public_path__ + "static/media/registration-trust.e0ab3fb1c92e84307c79dbb335e024b0.svg";
export { ForwardRef as ReactComponent };